module.exports = __webpack_public_path__ + "f2789a3c575cbc5f9cf4b7d8e1813517.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-96.cur
// module id = 487
// module chunks = 0